module.exports = __webpack_public_path__ + "img/4-min.7aa80070.jpg";